import React from 'react';
import { ToolComponentProps } from './types';
import { Globe, ChevronRight, ChevronDown } from 'lucide-react';

export const WebSearchTool: React.FC<ToolComponentProps> = ({
  input,
  output,
  isError,
  isExpanded,
  onToggle
}) => {
  // Extract search query from input
  const query = typeof input === 'string' ? input : input?.query || 'searching...';
  const hasOutput = output !== undefined && output !== null;

  // Format search results if available
  let results = [];
  if (output && !isError) {
    // Output is an array of search results
    if (Array.isArray(output)) {
      results = output;
    }
  }

  return (
    <div>
      <div
        className={`flex items-center gap-2 ${hasOutput ? 'cursor-pointer hover:bg-accent/30' : ''} rounded transition-colors`}
        onClick={hasOutput ? onToggle : undefined}
      >
        <Globe className="h-4 w-4 text-blue-500" />
        <span className="flex-1">Web search: {query}</span>
        <span className="text-muted-foreground inline-block w-3">
          {hasOutput && (isExpanded ? <ChevronDown className="h-3 w-3" /> : <ChevronRight className="h-3 w-3" />)}
        </span>
      </div>

      {isExpanded && hasOutput && (
        <div className={`mt-1 ml-6 ${isError ? 'text-destructive' : ''}`}>
          {isError ? (
            <div className="text-xs">Error: {output}</div>
          ) : (
            <ul className="text-xs space-y-0.5">
              {results.length > 0 ? (
                results.map((result: any, idx: number) => (
                  <li key={idx} className="flex items-start">
                    <span className="text-muted-foreground mr-1.5">•</span>
                    <a 
                      href={result.url} 
                      target="_blank" 
                      rel="noopener noreferrer"
                      className="text-blue-500 hover:underline"
                    >
                      {result.title || 'Untitled'}
                    </a>
                  </li>
                ))
              ) : (
                <li className="text-muted-foreground">No results found</li>
              )}
            </ul>
          )}
        </div>
      )}
    </div>
  );
};